import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const LinkBraun = ({ text, onClick, blackBorder }) => {
  const skipIntroRef = useRef();
  const pathRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      if (blackBorder) {
        if (skipIntroRef.current) {
          skipIntroRef.current.classList.add(styles.blackColor);
          pathRef.current.style.stroke = '#000';
        }
      }
    }, 9000);
  }, [skipIntroRef]);
  return (
    <div
      className={`${styles.button} ${
        styles.buttonBraun ? styles.buttonBraun : ''
      }`}
      onClick={onClick}
      ref={skipIntroRef}
    >
      {text}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.37 16.74">
        <g>
          <g>
            <path
              ref={pathRef}
              d="M1,1,8.37,8.37,1,15.74"
              style={{
                fill: 'none',
                stroke: '#fff',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '2px',
              }}
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

LinkBraun.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  blackBorder: PropTypes.bool,
};

export default LinkBraun;
